import _ from 'lodash'
import { constantsActive } from 'utils/constants/constants'

export default class HelperTimeslotGroups {
	
	static canSendInvitations( timeslotGroups ) {
		let result = false;
		_.forEach( timeslotGroups, timeslotGroup => {
			if( timeslotGroup.can_book_for_coworkers === constantsActive.YES || timeslotGroup.can_book_for_external === constantsActive.YES ) {
				result = true;
				
				// break out the loop
				return false;
			}
		})
		
		return result;
	}
	
	static getKindsAndSubKinds( timeslotGroup, timeslotKinds ) {
		const timeslotKindsForGroup = _.get( timeslotGroup, 'timeslots_kinds', [] );
		
		const _timeslotKinds = [];
		const _timeslotSubKinds = [];
		const _timeslotKindsForGroup = [];
		
		_.forEach( timeslotKindsForGroup, ( timeslotKindsForGroup ) => {
			const timeslotKind = _.get( _.filter( timeslotKinds, { guid: timeslotKindsForGroup.guid }, null ), 0, null );
			
			if ( timeslotKind !== null && typeof timeslotKind !== 'undefined' ) {
				_timeslotKinds.push( timeslotKind?.kind );
				_timeslotSubKinds.push( timeslotKind?.sub_kind );
				
				_timeslotKindsForGroup.push( timeslotKind );
			}
		});
		
		return {
			timeslotKinds: _.uniq( _timeslotKinds ),
			timeslotSubKinds: _.uniq( _timeslotSubKinds ),
			timeslotKindsForGroup: _timeslotKindsForGroup
		};
	}
}
